/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * TSOA-compatible version of `PropertyImportFilterCondition`.
 *
 * TSOA can struggle to resolve Zod-inferred defaulted fields, so this type
 * replaces the optional `matchType` with a required union that matches the
 * runtime schema defaults.
 */
export type TCPropertyImportFilterCondition = {
    /**
     * The value to match in the specified column.
     */
    value: string;
    /**
     * The spreadsheet column name to filter on.
     */
    columnName: string;
    /**
     * Filter matching strategy.
     *
     * - `equals`: Exact case-insensitive match (default)
     * - `contains`: Column value contains this value
     * - `startsWith`: Column value starts with this value
     */
    matchType: TCPropertyImportFilterCondition.matchType;
};
export namespace TCPropertyImportFilterCondition {
    /**
     * Filter matching strategy.
     *
     * - `equals`: Exact case-insensitive match (default)
     * - `contains`: Column value contains this value
     * - `startsWith`: Column value starts with this value
     */
    export enum matchType {
        EQUALS = 'equals',
        CONTAINS = 'contains',
        STARTS_WITH = 'startsWith',
    }
}

